import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

// Typography Title
export const TypographyTitleMeta: ComponentMeta = {
  componentName: "Typography.Title",
  package: "@mijadesign/web",
  title: "标题",
  description: "标题文本",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "FontSizeOutlined",
  canHaveChildren: true,
  props: [
    {
      name: "level",
      label: "级别",
      type: PropType.ENUM,
      defaultValue: 1,
      options: [
        { label: "H1", value: 1 },
        { label: "H2", value: 2 },
        { label: "H3", value: 3 },
        { label: "H4", value: 4 },
        { label: "H5", value: 5 },
      ],
      group: "基础",
    },
    {
      name: "copyable",
      label: "可复制",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "交互",
    },
    {
      name: "delete",
      label: "删除线",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "editable",
      label: "可编辑",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "交互",
    },
    {
      name: "ellipsis",
      label: "省略",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "mark",
      label: "标记",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "underline",
      label: "下划线",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "keyboard",
      label: "键盘样式",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "style",
      label: "样式",
      type: PropType.OBJECT,
      group: "样式",
    },
    {
      name: "className",
      label: "类名",
      type: PropType.STRING,
      group: "样式",
    },
  ],
  defaultProps: {
    level: 1,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Typography.Title",
  },
  snippet: {
    componentName: "Typography.Title",
    package: "@mijadesign/web",
    props: { level: 1 },
    children: [],
  },
};

// Typography Paragraph
export const TypographyParagraphMeta: ComponentMeta = {
  componentName: "Typography.Paragraph",
  package: "@mijadesign/web",
  title: "段落",
  description: "段落文本",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "AlignLeftOutlined",
  canHaveChildren: true,
  props: [
    {
      name: "copyable",
      label: "可复制",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "交互",
    },
    {
      name: "delete",
      label: "删除线",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "editable",
      label: "可编辑",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "交互",
    },
    {
      name: "ellipsis",
      label: "省略",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "mark",
      label: "标记",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "underline",
      label: "下划线",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "strong",
      label: "加粗",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "italic",
      label: "斜体",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "style",
      label: "样式",
      type: PropType.OBJECT,
      group: "样式",
    },
  ],
  npm: {
    package: "@mijadesign/web",
    exportName: "Typography.Paragraph",
  },
  snippet: {
    componentName: "Typography.Paragraph",
    package: "@mijadesign/web",
    props: {},
    children: [],
  },
};

// Typography Text
export const TypographyTextMeta: ComponentMeta = {
  componentName: "Typography.Text",
  package: "antd",
  title: "文本",
  description: "文本",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "FontSizeOutlined",
  visibleInComponentPanel: true,
  props: [
    {
      name: "children",
      label: "类型",
      type: PropType.STRING,
      bindable: true,
      bindSources: ["state", "record"],
      defaultValue: "default",
      group: "基础",
    },
    {
      name: "copyable",
      label: "可复制",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "交互",
    },
    {
      name: "delete",
      label: "删除线",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "disabled",
      label: "禁用",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "状态",
    },
    {
      name: "editable",
      label: "可编辑",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "交互",
    },
    {
      name: "ellipsis",
      label: "省略",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "mark",
      label: "标记",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "underline",
      label: "下划线",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "strong",
      label: "加粗",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "italic",
      label: "斜体",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "keyboard",
      label: "键盘样式",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "style",
      label: "样式",
      type: PropType.OBJECT,
      group: "样式",
    },
  ],
  npm: {
    package: "@mijadesign/web",
    exportName: "Typography.Text",
  },
  preview: [
    {
      title: "普通文本",
      props: {
        children: "这是一段普通文本",
      },
    },
    {
      title: "强调文本",
      props: {
        strong: true,
        children: "重点信息",
      },
    },
    {
      title: "标记文本",
      props: {
        mark: true,
        children: "高亮信息",
      },
    },
  ],
  docLinks: [
    {
      title: "Typography.Text 文档",
      url: "https://5x-ant-design.antgroup.com/components/typography-text-cn",
      source: "antd",
    },
  ],
  snippet: {
    componentName: "Typography.Text",
    package: "antd",
    props: {},
    children: [],
  },
};

// 导出所有 Typography 组件
export const TypographyMetaList = [
  TypographyTitleMeta,
  TypographyParagraphMeta,
  TypographyTextMeta,
];
